const MDHD_WORKFLOW_CONFIG_STORAGE_KEY = 'utility-mdhd-workflow-config';

const DEFAULT_MDHD_WORKFLOW_CONFIG = {
  managedCharging: {
    v2gMode: 'unmanaged',
    touSource: 'library',
    touDatasetId: null,
    touRateMeta: null,
    depotChargingPower: 50,
    enrouteChargingPower: 350,
  },
  vehicleConfiguration: {
    selectedVehicleIds: [],
  },
  evChargingBehavior: {
    socInitial: 0.95,
    socMax: 0.95,
    socMin: 0.1,
    socThreshold: 0.3,
  },
  seasonWeather: {
    weatherDatasetId: null,
  },
  ratePlan: {
    touSource: 'library',
    touDatasetId: null,
    touRateMeta: null,
  },
};

function isBrowser() {
  return typeof window !== 'undefined' && !!window.localStorage;
}

export function getDefaultMdhdWorkflowConfig() {
  return JSON.parse(JSON.stringify(DEFAULT_MDHD_WORKFLOW_CONFIG));
}

export function getMdhdWorkflowConfig() {
  if (!isBrowser()) return getDefaultMdhdWorkflowConfig();
  try {
    const raw = window.localStorage.getItem(MDHD_WORKFLOW_CONFIG_STORAGE_KEY);
    if (!raw) return getDefaultMdhdWorkflowConfig();
    const parsed = JSON.parse(raw);
    return {
      ...getDefaultMdhdWorkflowConfig(),
      ...(parsed || {}),
      managedCharging: {
        ...DEFAULT_MDHD_WORKFLOW_CONFIG.managedCharging,
        ...((parsed || {}).managedCharging || {}),
      },
      vehicleConfiguration: {
        ...DEFAULT_MDHD_WORKFLOW_CONFIG.vehicleConfiguration,
        ...((parsed || {}).vehicleConfiguration || {}),
      },
      evChargingBehavior: {
        ...DEFAULT_MDHD_WORKFLOW_CONFIG.evChargingBehavior,
        ...((parsed || {}).evChargingBehavior || {}),
      },
      seasonWeather: {
        ...DEFAULT_MDHD_WORKFLOW_CONFIG.seasonWeather,
        ...((parsed || {}).seasonWeather || {}),
      },
      ratePlan: {
        ...DEFAULT_MDHD_WORKFLOW_CONFIG.ratePlan,
        ...((parsed || {}).ratePlan || {}),
      },
    };
  } catch {
    return getDefaultMdhdWorkflowConfig();
  }
}

export function updateMdhdWorkflowConfig(section, values) {
  if (!section || !isBrowser()) return;
  const current = getMdhdWorkflowConfig();
  const next = {
    ...current,
    [section]: {
      ...(current[section] || {}),
      ...(values || {}),
    },
  };
  window.localStorage.setItem(MDHD_WORKFLOW_CONFIG_STORAGE_KEY, JSON.stringify(next));
}
